import api from './api'
import {
  ConsultorDetalhe,
  ConsultoresFiltros,
  ConsultoresResumo,
  ConsultorResumo,
  IndicadoresConsultor,
} from '@/types/consultor'
import { PageResponse } from '@/types/comum'

const BASE_URL = '/api/v1/consultores'

/**
 * Tela de Consultores (ADMIN). Cadastro e situação vêm do auth; os números de reservas,
 * do oportunidades — a página junta pelo `id`. Os dois respondem 403 fora do ADMIN.
 */
export const consultorService = {
  listar: async (filtros: ConsultoresFiltros = {}): Promise<PageResponse<ConsultorResumo>> => {
    const sp = new URLSearchParams()
    sp.append('page', String(filtros.page ?? 0))
    sp.append('size', String(filtros.size ?? 20))
    sp.append('sort', filtros.sort ?? 'nome,asc')
    if (filtros.busca?.trim()) sp.append('busca', filtros.busca.trim())
    if (filtros.situacao) sp.append('situacao', filtros.situacao)
    if (filtros.canal) sp.append('canal', filtros.canal)
    const response = await api.get<PageResponse<ConsultorResumo>>(`${BASE_URL}?${sp.toString()}`)
    return response as unknown as PageResponse<ConsultorResumo>
  },

  resumo: async (): Promise<ConsultoresResumo> => {
    const response = await api.get<ConsultoresResumo>(`${BASE_URL}/resumo`)
    return response as unknown as ConsultoresResumo
  },

  /** 404 para conta inexistente ou de back-office. */
  obter: async (id: string): Promise<ConsultorDetalhe> => {
    const response = await api.get<ConsultorDetalhe>(`${BASE_URL}/${encodeURIComponent(id)}`)
    return response as unknown as ConsultorDetalhe
  },

  indicadores: async (): Promise<IndicadoresConsultor[]> => {
    const response = await api.get<IndicadoresConsultor[]>('/api/v1/oportunidades/consultores/indicadores')
    return response as unknown as IndicadoresConsultor[]
  },
}
